module.exports = __webpack_public_path__ + "static/media/swimming.3661baf3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/carousel/images/swimming.jpg
// module id = 549
// module chunks = 0